// src/components/ConferencePopup/ConferencePopup.jsx

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import './ConferencePopup.css';

const WishForPop = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Mostrar el popup después de 5 segundos (ajustable)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setIsVisible(false);
  };

  const handleRegister = () => {
    // Aquí puedes agregar la lógica de registro
    // Por ejemplo, redirigir a un formulario de registro
    window.open('https://www.gestlifesurrogacy.com/conferencias', '_blank');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="conference-popup-overlay">
      <div className="conference-popup">
        {/* Header con imagen del Atomium */}
        <div className="conference-popup-header">
          <button
            onClick={closePopup}
            className="conference-popup-close"
            aria-label="Cerrar popup"
          >
            ×
          </button>
          
          {/* Estructura del Atomium estilizada */}
          <div className="atomium-container">
            <div className="atomium">
              <div className="sphere sphere-1"></div>
              <div className="sphere sphere-2"></div>
              <div className="sphere sphere-3"></div>
              <div className="sphere sphere-4"></div>
              <div className="sphere sphere-5"></div>
              <div className="sphere sphere-6"></div>
              <div className="sphere sphere-7"></div>
              
              <svg className="atomium-lines" viewBox="0 0 128 128">
                <line x1="64" y1="16" x2="32" y2="40" />
                <line x1="64" y1="16" x2="96" y2="40" />
                <line x1="32" y1="40" x2="64" y2="64" />
                <line x1="96" y1="40" x2="64" y2="64" />
                <line x1="64" y1="64" x2="32" y2="88" />
                <line x1="64" y1="64" x2="96" y2="88" />
                <line x1="32" y1="88" x2="64" y2="112" />
                <line x1="96" y1="88" x2="64" y2="112" />
              </svg>
            </div>
            
            {/* Efectos decorativos */}
            <div className="floating-dot dot-1"></div>
            <div className="floating-dot dot-2"></div>
            <div className="floating-dot dot-3"></div>
          </div>
        </div>

        {/* Contenido */}
        <div className="conference-popup-content">
          <div className="conference-popup-tag">
            {t('conference_popup_tag', '¡Encuéntranos en Bruselas!')}
          </div>

          <h2 className="conference-popup-title">
            {t('conference_popup_title_1', 'Salón')}
          </h2>
          <h3 className="conference-popup-title-2">
            {t('conference_popup_title_2', 'Wish For A Baby 2025')}
          </h3>

          <p className="conference-popup-description">
            {t('conference_popup_description', 
              'Si estás considerando la gestación subrogada y tienes preguntas sobre el proceso, las leyes o los requisitos, te invitamos a nuestras conferencias en vivo.'
            )}
          </p>

          <button
            onClick={handleRegister}
            className="conference-popup-button"
          >
            {t('conference_popup_button', 'REGÍSTRATE')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WishForPop;